import { Injectable } from '@angular/core';
import { userDtos } from '@vectronic/openApi-customer';
import { of } from 'rxjs';
import { ANIMAL_GROUPS } from '../animal-group.mock';
import { ANIMALS } from '../animal.mock';
import { COLLAR_GROUPS } from '../collar-group.mock';
import { COLLARS } from '../collar.mock';
import { TRAPS } from '../trap.mock';

@Injectable()
export class ItemEntityServicesMock {
  private hasUserAccessTo = () => ({ subscribe: () => null as any }) as any;
  collar = {
    entities$: of(COLLARS),
    getAll: () => of(COLLARS),
    getFilteredItems: () => of(COLLARS),
    hasUserAccessTo: this.hasUserAccessTo,
  };
  collarGroup = {
    entities$: of(COLLAR_GROUPS),
    getAll: () => of(COLLAR_GROUPS),
    hasUserAccessTo: this.hasUserAccessTo,
  };
  animal = {
    entities$: of(ANIMALS),
    getByKey: () => of(ANIMALS[1]),
    getAll: () => of(ANIMALS),
    hasUserAccessTo: this.hasUserAccessTo,
  };
  animalGroup = {
    entities$: of(ANIMAL_GROUPS),
    getAll: () => of(ANIMAL_GROUPS),
    hasUserAccessTo: this.hasUserAccessTo,
  };
  trap = {
    entities$: of(TRAPS),
    getAll: () => of(TRAPS),
    getFilteredItems: () => of(TRAPS),
    hasUserAccessTo: this.hasUserAccessTo,
  };
  trapGroup = {
    entities$: of(Array<userDtos.Group>),
    getAll: () => of(Array<userDtos.Group>),
    hasUserAccessTo: this.hasUserAccessTo,
  };
  dropOff = {
    entities$: of([]),
    getAll: () => of([]),
    getFilteredItems: () => of([]),
    hasUserAccessTo: this.hasUserAccessTo,
  };
}
